import { createContext, useContext, useMemo } from "react";
import { useAuth } from "auth/authProvider";

const TeamContext = createContext(null);

export function useTeamValue() {
  return useContext(TeamContext);
}

export function TeamProvider({ children }) {
  const{teams, permissions}=useAuth()

  const providerValue = useMemo(() => {
    return {
      permissions,
      allowAll: !Boolean(teams.length)
    };
  }, [permissions]);
  return <TeamContext.Provider value={providerValue}>{children}</TeamContext.Provider>;
}
